import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import { useWorkbenchRunStatus } from './workbench-run-status-context.js';

import type { ReactElement } from 'react';

const GENERIC_FAILURE = 'The connection to the assistant dropped. Send your message again to retry.';

/**
 * Failure notice for a run that ended badly — a dropped stream, a rejected
 * request, a backend error — so a dead workbench reads as dead rather than as one
 * still thinking. Renders nothing while the run is healthy.
 */
export function WorkbenchRunErrorBanner(): ReactElement | null {
	const status = useWorkbenchRunStatus((s) => s.status);
	const errorMessage = useWorkbenchRunStatus((s) => s.errorMessage);

	if (status !== 'error') {
		return null;
	}

	return (
		<div
			role='alert'
			className='flex shrink-0 items-start gap-2 border-t border-red-a5 bg-red-a2 px-3 py-2 text-sm text-red-11'
		>
			<ErrorOutlineIcon style={{ fontSize: 18 }} className='mt-px shrink-0' />
			<span className='min-w-0'>{errorMessage ?? GENERIC_FAILURE}</span>
		</div>
	);
}
